import { DependenciesInjection } from "app/di/DependencyInjection";
import { BussinessAppUserImpl } from "../data/BussinessAppUserImpl";
import { IBussinessAppUserRepository } from "../domain/repositories/IBussinessAppUserRepository";
import { BussinessAppUserUseCase } from "../domain/useCases/BussinessAppUserUseCase";
import { BussinessAppUserToken } from "./BussinessAppUserToken";
import { BusinessUserAppManagementViewModel } from "../presentation/viewModel/BusinessUserAppManagementViewModel";

export class BussinessAppUserInjection {
  static initInjection() {
    DependenciesInjection.register<IBussinessAppUserRepository>(
      BussinessAppUserToken.IBussinessAppUserRepository,
      BussinessAppUserImpl,
      "otherRepo",
    );
    DependenciesInjection.register<BussinessAppUserUseCase>(
      BussinessAppUserToken.BussinessAppUserUseCase,
      BussinessAppUserUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<BusinessUserAppManagementViewModel>(
      BussinessAppUserToken.BusinessUserAppManagementViewModel,
      BusinessUserAppManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IBussinessAppUserRepository>(
      BussinessAppUserToken.IBussinessAppUserRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<BussinessAppUserUseCase>(
      BussinessAppUserToken.BussinessAppUserUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<BusinessUserAppManagementViewModel>(
      BussinessAppUserToken.BusinessUserAppManagementViewModel,
    );
  }
}
